import { releaseQuery, visitorLogQuery } from '../ReportsAPI';
import {
    createReleaseByWorkOrderID,
    createVisitorByWorkOrderID,
    prepareData,
    applyWorkOrders,
} from './helpers/maintenance.helper';
import { getTurbineIdToNameMap } from 'common/state.helper';

const initialState = {
    timelineData: null,
};

export const parkMaintenance = {
    name: 'parkMaintenance',
    state: initialState,

    reducers: {
        setMaintenanceData(state, { timelineData }) {
            return { ...state, timelineData };
        },
    },

    effects: (dispatch) => ({
        async loadAll(_, state) {
            const releaseData = await prepareData(state, releaseQuery, 'return_time', createReleaseByWorkOrderID);

            const entityKeyToNameMap = await getTurbineIdToNameMap(state);

            const filteredReleaseData = releaseData.filter(
                ({ turbineData }) => entityKeyToNameMap[turbineData.turbineKey]
            );

            const visitorData = await prepareData(state, visitorLogQuery, 'end_time', createVisitorByWorkOrderID);

            const filteredVisitorData = visitorData.filter(
                ({ turbineData }) => entityKeyToNameMap[turbineData.turbineKey]
            );

            const maintenanceData = [...filteredReleaseData, ...filteredVisitorData];
            const timelineData = await applyWorkOrders(state, maintenanceData);

            dispatch.parkMaintenance.setMaintenanceData({ timelineData });
        },
    }),

    subscriptions: {
        setup() {
            // Any setup logic can go here if needed
        },
    },
};

export default parkMaintenance;
